export const state = () => ({
  open: false,
})

export const mutations = {
  setOverlay: (state, payload) => {
    state.open = payload
  },
}

export const getters = {
  overlayStatus: (state) => {
    return state.open
  },
}
